module.exports = __webpack_public_path__ + "static/agree2-992653e6bb5070989d69cf4d2adaf03b.png";